var map = {
	"./assets/emoji/emoji-1.png": "2c1c",
	"./assets/emoji/emoji-10.png": "7630",
	"./assets/emoji/emoji-11.png": "c630",
	"./assets/emoji/emoji-12.png": "736b",
	"./assets/emoji/emoji-13.png": "609b",
	"./assets/emoji/emoji-14.png": "668a",
	"./assets/emoji/emoji-15.png": "0966",
	"./assets/emoji/emoji-16.png": "70ce",
	"./assets/emoji/emoji-17.png": "cb00",
	"./assets/emoji/emoji-18.png": "d343",
	"./assets/emoji/emoji-19.png": "e144",
	"./assets/emoji/emoji-2.png": "0772",
	"./assets/emoji/emoji-20.png": "8610",
	"./assets/emoji/emoji-21.png": "ad20",
	"./assets/emoji/emoji-22.png": "bbe7",
	"./assets/emoji/emoji-23.png": "d967",
	"./assets/emoji/emoji-24.png": "10b4",
	"./assets/emoji/emoji-25.png": "cc07",
	"./assets/emoji/emoji-26.png": "ff6b",
	"./assets/emoji/emoji-27.png": "2460",
	"./assets/emoji/emoji-28.png": "6b9b",
	"./assets/emoji/emoji-29.png": "045c",
	"./assets/emoji/emoji-3.png": "2777",
	"./assets/emoji/emoji-30.png": "711d",
	"./assets/emoji/emoji-31.png": "3f54",
	"./assets/emoji/emoji-32.png": "9572",
	"./assets/emoji/emoji-33.png": "2c63",
	"./assets/emoji/emoji-34.png": "eeb9",
	"./assets/emoji/emoji-35.png": "b904",
	"./assets/emoji/emoji-36.png": "849f",
	"./assets/emoji/emoji-37.png": "7f83",
	"./assets/emoji/emoji-38.png": "209c",
	"./assets/emoji/emoji-39.png": "3054",
	"./assets/emoji/emoji-4.png": "0442",
	"./assets/emoji/emoji-40.png": "d627",
	"./assets/emoji/emoji-41.png": "b74c",
	"./assets/emoji/emoji-42.png": "5992",
	"./assets/emoji/emoji-43.png": "202c",
	"./assets/emoji/emoji-44.png": "69a6",
	"./assets/emoji/emoji-45.png": "29ec",
	"./assets/emoji/emoji-46.png": "1723",
	"./assets/emoji/emoji-47.png": "850d",
	"./assets/emoji/emoji-48.png": "39f9",
	"./assets/emoji/emoji-49.png": "f950",
	"./assets/emoji/emoji-5.png": "dbae",
	"./assets/emoji/emoji-50.png": "69e4",
	"./assets/emoji/emoji-51.png": "8760",
	"./assets/emoji/emoji-52.png": "231c",
	"./assets/emoji/emoji-53.png": "32a5",
	"./assets/emoji/emoji-54.png": "8333",
	"./assets/emoji/emoji-55.png": "058f",
	"./assets/emoji/emoji-56.png": "62d3",
	"./assets/emoji/emoji-57.png": "43ef",
	"./assets/emoji/emoji-58.png": "77f0",
	"./assets/emoji/emoji-59.png": "146e",
	"./assets/emoji/emoji-6.png": "b02d",
	"./assets/emoji/emoji-60.png": "97c0",
	"./assets/emoji/emoji-61.png": "f7f0",
	"./assets/emoji/emoji-62.png": "85ea",
	"./assets/emoji/emoji-63.png": "8699",
	"./assets/emoji/emoji-64.png": "5e52",
	"./assets/emoji/emoji-7.png": "881c",
	"./assets/emoji/emoji-8.png": "fd30",
	"./assets/emoji/emoji-9.png": "c14b",
	"./assets/images/answer.png": "43ca",
	"./assets/images/ask.png": "52e9",
	"./assets/images/blank/blank.png": "51ea",
	"./assets/images/blank/blank_orange.png": "44f3",
	"./assets/images/blank/duomeiti.png": "1f7d",
	"./assets/images/blank/duomeiti_orange.png": "10f4",
	"./assets/images/blank/gonggao.png": "587b",
	"./assets/images/blank/gonggao_orange.png": "0fc3",
	"./assets/images/blank/liaotianshenhe.png": "8a0a",
	"./assets/images/blank/liaotianshenhe_orange.png": "6928",
	"./assets/images/blank/shangpin.png": "ad67",
	"./assets/images/blank/shangpin_orange.png": "1fff",
	"./assets/images/blank/weizhibo-doc.png": "6654",
	"./assets/images/blank/weizhibo.png": "542a",
	"./assets/images/blank/weizhibo_orange.png": "6161",
	"./assets/images/chat_expand.png": "6e60",
	"./assets/images/chat_packup.png": "8345",
	"./assets/images/countDown/playing.png": "b424",
	"./assets/images/default_chatavatar.png": "ac54",
	"./assets/images/doc/isPub-TW-Orange.png": "1caf",
	"./assets/images/doc/isPub-TW.png": "f520",
	"./assets/images/doc/isPub-US-Orange.png": "c54d",
	"./assets/images/doc/isPub-US.png": "3a0e",
	"./assets/images/doc/isPub.png": "7066",
	"./assets/images/doc/ispub_orange.png": "a5bb",
	"./assets/images/doc/more.png": "1554",
	"./assets/images/gift/custom-logo.png": "0658",
	"./assets/images/gift/giftIcon1.png": "2379",
	"./assets/images/gift/giftIcon2.png": "7d47",
	"./assets/images/gift/giftIcon3.png": "15ab",
	"./assets/images/gift/giftIcon4.png": "f29c",
	"./assets/images/gift/giftIcon5.png": "c93d",
	"./assets/images/gift/giftIcon6.png": "7266",
	"./assets/images/gift/giftIcon7.png": "f37a",
	"./assets/images/gift/hongbao.png": "74e8",
	"./assets/images/guide.png": "5410",
	"./assets/images/layout/layout_select0.png": "7661",
	"./assets/images/layout/layout_select1.png": "3d20",
	"./assets/images/layout/layout_select2.png": "632b",
	"./assets/images/layout/layout_select5.png": "6fa7",
	"./assets/images/layout/upoad.png": "9278",
	"./assets/images/line.png": "fe82",
	"./assets/images/line_orange.png": "f4a5",
	"./assets/images/login.png": "24a9",
	"./assets/images/loginerr.png": "13d7",
	"./assets/images/logo.png": "9d64",
	"./assets/images/lucking.png": "ec7c",
	"./assets/images/no-permission.png": "131c",
	"./assets/images/noneWinner.png": "101a",
	"./assets/images/overicon.png": "c010",
	"./assets/images/playError.png": "9a18",
	"./assets/images/upload/pdf.png": "bdb7",
	"./assets/images/upload/pic.png": "5db7",
	"./assets/images/upload/ppt.png": "23ad",
	"./assets/images/upload/txt.png": "d179",
	"./assets/images/upload/word.png": "6ea1",
	"./assets/logo.png": "cf05",
	"./svg/icon/iconheart.png": "e500",
	"./svg/mic-sprite0.png": "8471",
	"./svg/mic-sprite1.png": "c1aa",
	"./svg/mic-sprite2.png": "ff5d",
	"./svg/mic-sprite3.png": "74ec",
	"./svg/mic-sprite4.png": "b99d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fe6";